export enum HarvestTypeFilter {
  ALL = 'ALL',
  LTCG = 'LTCG',
  STCG = 'STCG',
  LTCL = 'LTCL',
  STCL = 'STCL'
}
export type TransactionSource = 'EXTERNAL' | 'POWERUP'

export interface FinancialYearCapitalGains {
  ltcg: number
  stcg: number
  ltcl: number
  stcl: number
}

export interface WithdrawTransaction {
  isin: string
  fundName: string
  logo: string
  financialYearCapitalGains: FinancialYearCapitalGains
  transactionDate: number
  transactionSource: TransactionSource
  transactionAmount: number
  harvestingTypeFilters?: HarvestTypeFilter[]
}

export interface WithdrawalsResponse {
  totalRealisedGains: number
  netRealisedLtcg: number
  netRealisedStcg: number
  totalWithdrawal: number
  withdrawTransactionList: WithdrawTransaction[]
}
